import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import SystemStatus from '../../components/SystemStatus/SystemStatus';

export const SystemStatusRouting = (props: LogicalRouteImportProps) => {
    const disabled = !useHasPermissions({ permission: Pages.SYSTEM_STATUS, role: Roles.VIEWER });

    return <LogicalRoute {...props} component={SystemStatus} disabled={disabled} />;
};
